module.exports = __webpack_public_path__ + "static/img/c.e4822a96.png";